import { useContextBarAppearance } from "@/contexts/ContextBarAppearanceContext";
import LinkObject from "@/domain/entities/emails/LinkObject";
import { cn } from "@/lib/utils";
import { Link } from "lucide-react";

interface LinkItemProps {
    link: LinkObject;
}

const LinkItem = ({ link }: LinkItemProps) => {
    const { isDeepFocus } = useContextBarAppearance();

    return (
        <a
            className={cn(
                "transition-duration-300 flex w-full items-center gap-4 break-all rounded-md px-3 py-2 text-left text-sm font-medium text-text-mainTitle transition-colors hover:bg-surface-primaryHover",
                isDeepFocus && "text-white hover:bg-white/10",
            )}
            href={link.url}
            rel="noreferrer"
            target="_blank"
        >
            <Link className="h-5 w-5 flex-shrink-0" href={link.url} />
            <span className="block">{link.name}</span>
        </a>
    );
};

export default LinkItem;
